/* eslint-disable no-console */
/* eslint-disable react/require-default-props */
import { Box } from '@mui/material';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import FeedbackScreen from '../../components/FeedbackScreen/FeedbackScreen';
import { WHATSAPP_LINK } from '../constants/configurations';

interface IErrorBoundaryProps {
  children?: ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  public static getDerivedStateFromError(_: Error): IErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  onClickWhatsapp = () => {
    window.open(WHATSAPP_LINK);
    window.location.reload();
  };

  public render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return (
        <Box>
          <FeedbackScreen status="REJECTED" onClick={this.onClickWhatsapp} />
        </Box>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
